import React from "react";

import { Divider } from "../../ui/divider";
import { HStack } from "../../ui/hstack";
import { Text } from "../../ui/text";
import { VStack } from "../../ui/vstack";
import { formatMoneyFromFragment } from "../../utils/money";
import InfoHint from "./InfoHint";
import { PaymentBreakdownLine } from "./types";

type Props = {
  line: PaymentBreakdownLine;
};

const LineLabel = ({ line }: Props) => (
  <HStack space="xs" className="items-center flex-1 shrink">
    {line.role === "TOTAL" ? (
      <Text size="md" bold>
        {line.label}
      </Text>
    ) : (
      <Text size="sm" action="muted">
        {line.label}
      </Text>
    )}
    {line.description ? <InfoHint content={line.description} /> : null}
  </HStack>
);

const Line = React.memo(({ line }: Props) => {
  const formattedAmount = formatMoneyFromFragment(line.amount);
  const ariaLabel = `${line.label}: ${formattedAmount}`;

  const row = (
    <HStack
      space="sm"
      className={
        line.role === "TOTAL"
          ? "items-center justify-between pt-2"
          : "items-center justify-between"
      }
      aria-label={ariaLabel}
    >
      <LineLabel line={line} />
      {line.role === "TOTAL" ? (
        <Text size="lg" bold className="text-typography-950">
          {formattedAmount}
        </Text>
      ) : (
        <Text className="font-medium text-typography-900">
          {formattedAmount}
        </Text>
      )}
    </HStack>
  );

  if (line.role === "LINE") return row;

  return (
    <VStack space="xs">
      <Divider />
      {row}
    </VStack>
  );
});

Line.displayName = "Line";

export default Line;
